import { message } from "antd";
import { checkAuthorization } from "../../helpers";
import { domainUrl } from "../../constants";

const createMasterPortal = (data) => {
  const { userToken } = checkAuthorization();
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", userToken);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
    redirect: "follow",
  };

  return fetch(domainUrl + "/masterPortals", requestOptions)
    .then((res) => res.json())
    .then((result) => {
      if (result.success) {
        message.success("Url update successfully.");
        return 1;
      }
      throw result.message;
    })
    .catch((err) => {
      message.error(err || "Something went wrong");
      return 0;
    });
};

const searchUrl = (url) => {
  const { userToken } = checkAuthorization();
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", userToken);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({ url }),
    redirect: "follow",
  };

  return fetch(domainUrl + "/filterPortals", requestOptions)
    .then((res) => res.json())
    .then((result) => {
      if (result.success) {
        return result.data;
      }
      throw result.message;
    })
    .catch((err) => {
      message.error(err || "Something went wrong");
      return [];
    });
};

const getVendorList = () => {
  const { userToken } = checkAuthorization();
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", userToken);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(domainUrl + "/master-portal/vendors", requestOptions)
    .then((res) => res.json())       // { success: true, data: [...] }
    .catch((err) => {
      message.error(err || "Vendor list fetch failed");
      return { success: false, data: [] };
    });
};

const masterPortal = {
  createMasterPortal,
  searchUrl,
  getVendorList,
};

export { masterPortal };
